import { useState } from "react";
import { Switch, message } from "antd";
import { HiOutlineCog } from "react-icons/hi";
import { api } from "@/lib/apiClient";

type Props = {
  selfRevealEnabled: boolean;
  eventSlug: string;
  onToggle?: (enabled: boolean) => void;
};

const DrawOnAttendeeApp = ({ selfRevealEnabled: initialEnabled, eventSlug, onToggle }: Props) => {
  const [enabled, setEnabled] = useState(initialEnabled);

  const handleToggle = async (checked: boolean) => {
    setEnabled(checked);
    try {
      await api.patch(`/events/${eventSlug}/lucky_draw/self_reveal`, {
        enabled: checked,
      });
      onToggle?.(checked);
      message.success(`Self reveal ${checked ? "enabled" : "disabled"}`);
    } catch (error) {
      console.error("Error updating self reveal setting:", error);
      message.error("Failed to update setting");
      setEnabled(!checked); // Revert on error
      onToggle?.(!checked);
    }
  };

  return (
    <div className="p-6">
      <div className="bg-white border border-gray-100 rounded-lg p-6 max-w-2xl">
        <div className="flex items-center gap-2 mb-6">
          <HiOutlineCog className="text-xl text-gray-600" />
          <h3 className="text-lg font-medium m-0">Draw on Attendee App</h3>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium mb-1">Self reveal prizes on the attendee app</p>
            <p className="text-sm text-gray-500 m-0">
              Enable this to allow winners to view their assigned prizes in the attendee app upon
              login.
            </p>
          </div>
          <Switch checked={enabled} onChange={handleToggle} />
        </div>
      </div>
    </div>
  );
};

export default DrawOnAttendeeApp;
